import React from "react";
import { StethoscopeIcon } from "lucide-react";
import { images } from "../../data/content";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
export function Hero() {
  return <header className="bg-cream-100 px-5 pb-14 pt-8 md:pt-12" data-id="element-166" data-mp="cy7dn9b1g2dw">
      <div className="mx-auto max-w-5xl text-center" data-id="element-167" data-mp="hvqqc4s3873q">
        <div className="flex items-center justify-center gap-2.5" data-id="element-168" data-mp="muadu9mbxqy7">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy-900 text-gold-300" data-id="element-169" data-mp="mrxzs7jp00qf">
            <StethoscopeIcon className="h-5 w-5" aria-hidden="true" data-id="element-170" data-mp="qt9f9k8ur5kw" />
          </span>
          <span className="font-serif text-xl font-bold text-navy-900" data-id="element-171" data-mp="vn45l6iyqisy">
            Rhinoplasty <span className="text-gold-700" data-id="element-172" data-mp="10kxew8fkbsxg">MasterMap™</span>
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl font-serif text-[34px] font-extrabold leading-[1.1] text-navy-950 sm:text-5xl md:text-6xl" data-id="element-173" data-mp="15ltdq7l24ow0">
          Analyze and structure a rhinoplasty case in{" "}
          <em className="text-gold-700" data-id="element-174" data-mp="9olxc8cunwmu">15 minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted md:text-xl" data-id="element-175" data-mp="4o6ljl87ux6z">
          A step-by-step visual system that turns any case into a clear framework of observations, priorities, objectives, and decision points — before you define your surgical strategy. Includes{" "}
          <strong className="text-ink" data-id="element-176" data-mp="setum9tvbsv4">6 premium volumes</strong>, <strong className="text-ink" data-id="element-177" data-mp="sgeqq3vtzjv3">5 professional tools</strong>, educational cases, decision maps, matrices, and checklists.
        </p>

        <img src={images.mainMockup} alt="Rhinoplasty MasterMap™ — 6 volumes, digital devices, and 5 bonus books" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-178" data-mp="inz7z4cpmr95" />

        <div className="mt-4" data-id="element-179" data-mp="1b5bnceepaogh">
          <CtaButton id="hero-cta" label="I want the MasterMap" note="Instant download · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-180" data-mp="1b5lcy0vu2tln" />
        </div>

        <div className="mt-8 space-y-6" data-id="element-181" data-mp="30mfgvqk6rpe4">
          <Countdown data-id="element-182" data-mp="35kqu8b9owi13" />
          <ScarcityBar data-id="element-183" data-mp="35la2f09jfs1x" />
        </div>
      </div>
    </header>;
}